module.exports = __webpack_public_path__ + "static/gradient_1-6a242fa31207031fc8eb8a923a1cbdbe.png";